import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useScrollAnimation } from './useScrollAnimation';
export function ServicesSection() {
  const ref = useScrollAnimation();
  const services = [{
    num: 1,
    title: 'Backyard Cleaning',
    desc: 'Fast, reliable care for your outdoor space — debris removal, lawn care, and power washing with eco-friendly solutions.',
    img: 'https://cdn.magicpatterns.com/uploads/ahgarkrhWBWZi14WY7Vatg/lpw-service-backyard-cleaning-488x650.webp'
  }, {
    num: 2,
    title: 'Commercial Cleaning',
    desc: 'Comprehensive commercial cleaning to keep your workspace spotless and professional.',
    img: 'https://cdn.magicpatterns.com/uploads/wNfvE2GAtkNAfy1MY4Qa6Y/bcpw-service-commercial-cleaning-576x1024.webp'
  }, {
    num: 3,
    title: 'Driveway Cleaning',
    desc: "Remove stains, dirt, and debris. Eco-friendly methods that restore your driveway's original look.",
    img: 'https://cdn.magicpatterns.com/uploads/u5rvnHTQ8C2zZ747ot3d8a/lpw-service-driveway-cleaning-488x650.webp'
  }, {
    num: 4,
    title: 'Paver Cleaning',
    desc: 'Restore outdoor spaces by removing dirt, stains, and weeds — keeping pavers beautiful and durable.',
    img: 'https://cdn.magicpatterns.com/uploads/3MyhdEBmvuewzveVgi1yVk/lpw-service-paver-cleaning-488x650.webp'
  }, {
    num: 5,
    title: 'Solar Panel Cleaning',
    desc: 'Improve energy efficiency by removing dirt and debris with safe, eco-friendly methods.',
    img: 'https://cdn.magicpatterns.com/uploads/7mkWmxZ6rJMX6ZT3SbVLdq/lpw-service-solar-panel-cleaning-577x1024.webp'
  }, {
    num: 6,
    title: 'Trash Can Cleaning',
    desc: 'Sanitize your bins and eliminate grime, bacteria, and odors for a fresh, hygienic solution.',
    img: 'https://cdn.magicpatterns.com/uploads/s8dNva1jhGj3tfrzpuizCn/lpw-service-trash-can-cleaning-488x650.webp'
  }, {
    num: 7,
    title: 'Window Cleaning',
    desc: 'Squeaky clean glass inside and out — we clean the windows and surrounding areas.',
    img: 'https://cdn.magicpatterns.com/uploads/4wiNEq1mR2Agh4kR5DHda3/lpw-service-window-cleaning-600x450.webp'
  }];
  return <section id="services" className="w-full py-20 px-4" style={{
    backgroundColor: '#E8F4FD'
  }} data-id="element-200">
      <div className="max-w-7xl mx-auto" ref={ref} data-id="element-201">
        {/* Heading */}
        <div className="text-center mb-14 scroll-animate" data-id="element-202">
          <h2 className="font-bold mb-4" style={{
          fontFamily: 'Montserrat, sans-serif',
          fontSize: 'clamp(26px, 4vw, 40px)',
          color: '#0283C7',
          fontWeight: 800,
          lineHeight: 1.1
        }} data-id="element-203">
            Exceptional Exterior Cleaning Services
          </h2>
          <p className="max-w-3xl mx-auto" style={{
          color: '#374151',
          fontFamily: 'Inter, sans-serif',
          fontSize: '16px',
          lineHeight: 1.6
        }} data-id="element-204">
            Transform your property with professional power washing. Enhance
            curb appeal and maintain a pristine look with our expert care.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7" data-id="element-205">
          {services.map((s, i) => <div key={s.num} className="scroll-animate bg-white rounded-2xl overflow-hidden flex flex-col group" style={{
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(2,131,199,0.08)',
          transitionDelay: `${i * 0.1}s`
        }} data-id="element-206">
              <div className="relative overflow-hidden" data-id="element-207">
                <img src={s.img} alt={s.title} className="w-full h-48 object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-208" />
                {/* Blue overlay on hover */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
              backgroundColor: 'rgba(2,131,199,0.25)'
            }} data-id="element-209" />
                <span className="absolute top-3 left-3 w-8 h-8 rounded-full flex items-center justify-center font-bold text-white text-sm" style={{
              backgroundColor: '#0283C7',
              fontFamily: 'Montserrat, sans-serif'
            }} data-id="element-210">
                  {s.num}
                </span>
              </div>
              <div className="p-6 flex flex-col flex-1" data-id="element-211">
                <h3 className="font-bold mb-2" style={{
              fontFamily: 'Montserrat, sans-serif',
              fontSize: '20px',
              color: '#0283C7',
              fontWeight: 700
            }} data-id="element-212">
                  {s.title}
                </h3>
                <p className="mb-4 flex-1" style={{
              color: '#374151',
              fontFamily: 'Inter, sans-serif',
              fontSize: '15px',
              lineHeight: 1.6
            }} data-id="element-213">
                  {s.desc}
                </p>
                <a href="#services" className="font-semibold flex items-center gap-1 transition-all hover:gap-2 hover:opacity-80" style={{
              color: '#0283C7',
              fontFamily: 'Inter, sans-serif',
              fontSize: '14px'
            }} data-id="element-214">
                  Learn More <ArrowRightIcon className="h-4 w-4" data-id="element-215" />
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}